<template>
<div style="margin: 0 40px;height: 500px;overflow-y: auto">
  <el-form size="small" style="margin-right: 30px" :model="diseaseForm" :rules="diseaseRules" ref="diseaseForm" label-width="150px" class="demo-ruleForm old-person">
    <el-form-item label="心血管疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseHeart">
        <el-checkbox v-for="item in diseaseHeart" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="血压疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseasePressSure">
        <el-checkbox v-for="item in diseasePressSure" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="脑血管疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseBrain">
        <el-checkbox v-for="item in diseaseBrain" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="高脂血症：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseFat">
        <el-checkbox v-for="item in diseaseFat" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="慢性呼吸道疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseBreath">
        <el-checkbox v-for="item in diseaseBreath" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="消化道疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseAlimentary">
        <el-checkbox v-for="item in diseaseAlimentary" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="代谢性疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseMetabolism">
        <el-checkbox v-for="item in diseaseMetabolism" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="骨关节疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseBone">
        <el-checkbox v-for="item in diseaseBone" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="特殊病例：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseSpecial">
        <el-checkbox v-for="item in diseaseSpecial" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="健康档案疾病：" prop="">
      <el-checkbox-group v-model="diseaseForm.diseaseHealthy">
        <el-checkbox v-for="item in diseaseHealthy" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="备注：" prop="">
      <el-input v-model="diseaseForm.note" placeholder="如有其它病症 请详细说明"></el-input>
    </el-form-item>
    <el-form-item label="就诊医院：" prop="">
      <el-input v-model="diseaseForm.hospital" placeholder="经常就诊医院"></el-input>
    </el-form-item>
    <div style="height: 30px;font-weight: bold;font-size: 18px"><span>健康档案</span></div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="常用药：" prop="">
          <el-input type="textarea" :rows="2" placeholder="请输入常用药" v-model="diseaseForm.oftenMedicine"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="忌用药：" prop="">
          <el-input type="textarea" :rows="2" placeholder="请输入忌用药" v-model="diseaseForm.tabooMedicine"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="老人类型：" prop="">
          <el-select v-fixZoom v-model="diseaseForm.oldPersonType" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in oldPersonType" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="血型：" prop="">
          <el-input v-model="diseaseForm.bloodType" placeholder="请输入血型"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="慢性疾病：" prop="">
          <el-select v-fixZoom v-model="diseaseForm.diseaseSlow" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in diseaseSlow" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="药物过敏史：" prop="">
          <el-input v-model="diseaseForm.allergenMedicine" placeholder="请输入药物过敏史"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="付费方式：" prop="payment_status_code">
      <el-radio-group v-model="diseaseForm.payment_status_code">
        <el-radio :label="1">公费</el-radio>
        <el-radio :label="2">半自费(部分享受养老服务补贴)</el-radio>
        <el-radio :label="3">自费</el-radio>
        <el-radio :label="9">不详</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('diseaseForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {updateelderly} from '../../../api/yanglaoyuan'

export default {
  name: 'oldPersonDisease',
  props: {
    diseaseObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isJujia: false,
      oldPersonRow: '',
      // entityelderlyservice: '',
      diseaseForm: {
        id: '',
        extra_info: {},
        // 老人病史
        diseaseHistory: {},
        diseaseHeart: [],
        diseasePressSure: [],
        diseaseBrain: [],
        diseaseFat: [],
        diseaseBreath: [],
        diseaseAlimentary: [],
        diseaseMetabolism: [],
        diseaseBone: [],
        diseaseSpecial: [],
        diseaseHealthy: [],
        diseaseSlow: [],
        note: '',
        hospital: '',
        oftenMedicine: '',
        tabooMedicine: '',
        oldPersonType: '',
        bloodType: '',
        allergenMedicine: '',
        payment_status_code: ''
      },
      diseaseRules: {
        // admission_personnel_type: [{required: true, message: '请选择老人类型', trigger: 'change'}],
        payment_status_code: [{required: true, message: '请选择付费情况', trigger: 'change'}]
      },
      diseaseHeart: [],
      diseasePressSure: [],
      diseaseBrain: [],
      diseaseFat: [],
      diseaseBreath: [],
      diseaseAlimentary: [],
      diseaseMetabolism: [],
      diseaseBone: [],
      diseaseSpecial: [],
      diseaseHealthy: [],
      oldPersonType: [],
      diseaseSlow: []
    }
  },
  created () {
    this.diseaseSlow = this.commonType.getDiseaseSlowArr()
    this.diseaseHeart = this.commonType.getDiseaseHeartArr()
    this.diseasePressSure = this.commonType.getDiseasePressSureArr()
    this.diseaseBrain = this.commonType.getDiseaseBrainArr()
    this.diseaseFat = this.commonType.getDiseaseFatArr()
    this.diseaseBreath = this.commonType.getDiseaseBreathArr()
    this.diseaseAlimentary = this.commonType.getDiseaseAlimentaryArr()
    this.diseaseMetabolism = this.commonType.getDiseaseMetabolismArr()
    this.diseaseBone = this.commonType.getDiseaseBoneArr()
    this.diseaseSpecial = this.commonType.getDiseaseSpecialArr()
    this.diseaseHealthy = this.commonType.getDiseaseHealthyArr()
    this.oldPersonType = this.commonType.getOldPersonTypeArr()
    this.oldPersonRow = this.diseaseObj.oldPersonRow
    console.log(this.diseaseObj.isJuJia)
    this.isJujia = this.diseaseObj.isJuJia
    this.getStartDisease()
  },
  methods: {
    getStartDisease () {
      // console.log('基本信息。', this.oldPersonRow)
      if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
        this.$message({
          message: '请先新增老人基本信息。',
          type: 'warning'
        })
        return
      }
      let info = null
      if (this.oldPersonRow.extra_info && this.oldPersonRow.extra_info !== '') {
        info = JSON.parse(this.oldPersonRow.extra_info)
      }
      // console.log(info)
      this.diseaseForm = this.commonType.getOldPersonForm(this.oldPersonRow, info)
      console.log(2, this.diseaseForm)
    },
    closeAddEdit () {
      this.$emit('changeEndDisease', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      let vm = this
      console.log(this.isJujia)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.commonType.getJsonInfo(this.diseaseForm)
          if (vm.isJujia) {
            this.$emit('changeEndDisease', data.extra_info)
          } else {
            updateelderly(data).then(res => {
              let obj = {
                type: 'isBtnDisease',
                diseaseForm: this.diseaseForm,
                extra_info: data.extra_info
              }
              this.$emit('changeEndDisease', obj)
              this.$notify({title: '成功', message: '成功编辑老人病史', type: 'success', duration: 2000})
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.title-line{
  color: #1a1a1a;
  letter-spacing: 2px;
  height: 30px;
  font-weight: bold;
  font-size: 16px;
}
.info-line{
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/oldPersonDisease.vue